import { client, DEFAULT_HEADERS } from "./defaultClient";
import { Story, PostStoryRequest } from "./generated";

export const createStory = async (
    request: PostStoryRequest,
    csrfToken: string
): Promise<Story> => {
    return await client.postStory(
        {
            postStoryRequest: request,
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};
